// src/store/subscriptionPurchaseModalManagment/types.ts
//
// Pendant de purchaseModalManagment pour un achat en mode abonnement : pas de panier
// (cartId) ici, la ressource choisie vient directement du catalogue — productVariantCode
// + priceCode suffisent à SubscriptionCreation (cf. backendServices/subscriptionManagment).

export const OPEN_SUBSCRIPTION_PURCHASE_MODAL  = 'OPEN_SUBSCRIPTION_PURCHASE_MODAL';
export const CLOSE_SUBSCRIPTION_PURCHASE_MODAL = 'CLOSE_SUBSCRIPTION_PURCHASE_MODAL';

export interface SubscriptionPurchaseModalState {
  open:               boolean;
  productVariantCode: string | null;
  priceCode:          string | null;
  amount:             number;  // centimes, TTC — pour affichage seul, pas envoyé tel quel
  label:              string;  // nom du produit, transmis en commentaire de l'abonnement
}

export const initialState: SubscriptionPurchaseModalState = {
  open:               false,
  productVariantCode: null,
  priceCode:          null,
  amount:             0,
  label:              '',
};

export interface OpenSubscriptionPurchaseModalAction {
  type: typeof OPEN_SUBSCRIPTION_PURCHASE_MODAL;
  payload: {
    productVariantCode: string;
    priceCode:          string;
    amount:             number;
    label:              string;
  };
}

export interface CloseSubscriptionPurchaseModalAction {
  type: typeof CLOSE_SUBSCRIPTION_PURCHASE_MODAL;
}

export type SubscriptionPurchaseModalActionTypes =
  | OpenSubscriptionPurchaseModalAction
  | CloseSubscriptionPurchaseModalAction;
